export const moderation = {
  withoutTranscriptionTitle: "Recordings without transcription",
  withoutTranscriptionEmpty: "All recordings have word-level transcriptions.",
  transcribeSelected: "Transcribe selected",
  transcribeSelectedCount: "Transcribe selected ({{count}})",
  noAudioFile: "No audio file available for transcription",
  bulkTranscriptionQueued: "{{count}} transcription requests queued",
  bulkTranscriptionSkipped:
    "{{queued}} queued, {{skipped}} skipped (already in progress or no audio file)",
  viewInProject: "View in project",
  viewInProjectNoPin: "This recording is not linked to a pin, so it cannot be opened in the project list.",
  markNonEnglish: "Mark as non-English",
  markedNonEnglish: "Recording marked as non-English and removed from this list",
  markNonEnglishFailed: "Could not mark recording as non-English",
  deleteFailed: "Could not delete the recording",
};
